import React, { useEffect, useState} from 'react';
import PropTypes from 'prop-types';
import SearchSelector from '../search-selector/';
import AddAlbum from '../add-album/';

const AlbumSelector = ({albumData, allowAdd, artistData, disabled, hideList, onBlurWithNewAlbum, onChange, onDeselect, onNewAlbumAdded, onSelect, zIndex}) => {
	const [foundAlbums, setFoundAlbums] = useState();
	const [isAddingAlbum, setIsAddingAlbum] = useState(false);
	const [isSelected, setIsSelected] = useState(false);
	const [isLoading, setIsLoading] = useState(true);
	const [newAlbumAdded, setNewAlbumAdded] = useState(null);
	const [albums, setAlbums] = useState(mapAlbums(artistData));

	function mapAlbums(data) {
		if (data && data.albums) {
			return Object.entries(data.albums).map(([key, value]) => {
				return {id: key, name: value}
			});
		};
		return [];
	}

	useEffect(() => {
		setAlbums(mapAlbums(artistData));
		setIsSelected(false);
	}, [artistData]);

	useEffect(() => {
		if (albumData.name === '') {
			setIsSelected(false);
		}
	}, [albumData]);

	useEffect(() => {
		if (!albums.length && newAlbumAdded === null) {
			setIsLoading(true);
			setNewAlbumAdded(false);
		} else if (albums.length && newAlbumAdded === true) {
			setIsLoading(false);
			setNewAlbumAdded(false);
		} else {
			setIsLoading(false);
		}
		setFoundAlbums(albums);
	}, [albums, newAlbumAdded]);

	const handleNewAlbumExit = () => {
		setIsAddingAlbum(false);
	}

	const handleNewAlbumSubmit = (album) => {
		onNewAlbumAdded && onNewAlbumAdded(album);
		setIsAddingAlbum(false);
		setIsLoading(true);
		setNewAlbumAdded(true);
	}

	function handleInputChange (val) {
		onChange(val);
	}

	const handleAlbumSearch = (val) => {
		setFoundAlbums(albums.filter((album) => {
			return album.name.toUpperCase().indexOf(val.toUpperCase()) > -1;
		}));
	}

  const handleAddAlbum = (data) => {
		setIsAddingAlbum(true);
  }

	const getAlbum = (val) => {
		if (artistData && artistData.albums && artistData.albums[val.id]) {
			return val;
		}
		return;
	}

	const handleAlbumSelect = (val) => {
		const selectedAlbumObj = getAlbum(val);
		onSelect && onSelect(selectedAlbumObj);
		setIsSelected(true);
  }

	const handleAlbumDeselect = (albumName) => {
		onDeselect(albumName);
		setIsSelected(false);
		setFoundAlbums(albums);
  }

	function handleBlurWithNewAlbum (val) {
		if (!(val && val.length)) {
			return;
		}
		onBlurWithNewAlbum(val);
		setIsSelected(true);
	}
	return (
		<div className="album-selector">
			{ disabled ? (
					<div className="form-element disabled">
					<h2>Album:</h2>
					<div className="input-wrap">
						<div className="dead-input">{albumData && albumData.name}</div>
					</div>
				</div>
			) :
			<SearchSelector
				items={foundAlbums}
				disabled={disabled || !artistData}
				fieldIdentifier="Album"
				hideList={hideList}
				onBlurWithNewItem={handleBlurWithNewAlbum}
				onChange={handleInputChange}
				onSearch={handleAlbumSearch}
				onSelect={handleAlbumSelect}
				onDeselect={handleAlbumDeselect}
				onAddClick={allowAdd ? handleAddAlbum : null}
				assistiveText={{
					noResults: artistData ? `No albums found for ${artistData.name}. Begin typing to create one.` : null,
					createNew: artistData ? `Create new ${artistData.name} album` : null
				}}
				isSelected={isSelected}
				zIndex={zIndex}
				value={albumData}
				isLoading={isLoading}
				loadingText="Loading Albums..."
			/>}
			{isAddingAlbum &&
				<AddAlbum
					albumData={{artist: artistData, name: null}}
					onSubmit={handleNewAlbumSubmit}
					onExit={handleNewAlbumExit}
					mode="modal"
				/>
			}
		</div>
	)
};

AlbumSelector.propTypes = {
	albumData: PropTypes.object,
	artistData: PropTypes.object,
	disabled: PropTypes.bool,
	hideList: PropTypes.bool,
	onBlurWithNewAlbum: PropTypes.func,
	onDeselect: PropTypes.func,
	onNewAlbumAdded: PropTypes.func,
	onSelect: PropTypes.func,
	zIndex: PropTypes.string
};

export default AlbumSelector;
